import {convertStringToTemperatureUnit, convertTemperature, ETemperatureUnit} from "contracts/ETemperatureUnit";
import {useContext, useMemo} from 'react';
import {OrganisationContext} from "utils/organisationContext";

export const useTemperatureConverterForOrganisation = () => {
    const organisation = useContext(OrganisationContext);

    const temperatureUnitForOrganization = useMemo<ETemperatureUnit>(() => {
        return convertStringToTemperatureUnit(organisation?.temperatureUnit);
    }, [organisation?.temperatureUnit]);

    const convert = useMemo(() => {
        return (value: string | number, inputUnit: ETemperatureUnit) => {
            return convertTemperature(value, inputUnit, temperatureUnitForOrganization);
        };
    }, [temperatureUnitForOrganization]);

    return {convert, temperatureUnit: temperatureUnitForOrganization};
}
